import { authRequest } from '../Request';
import { API_URL } from '../../config';

export const uploadFile = (value) =>
  authRequest()
    .post(`${API_URL}/api/v1/storage`)
    .attach('file', value);
